<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .read-more {
    @include colors.color("primary_50");
    cursor: pointer;

    // remove styling from button
    border: 0;
    background: none;
    padding: 0;
  }
</style>

<script>
  export let text = ""; // Text to be truncated
  export let size = "normal"; // Determines mixin style above
  export let limit = 200; // Number of characters to show before truncation
  export let showReadMore = true; // Set to false to never expand the text
  export let buttonStyle = ""; // Additional styles for the read more button

  let expanded = false;
  const toggleExpanded = () => {
    expanded = !expanded;
  };

  // Check if the text should be truncated
  const exceedsLimit = text.length > limit;

  // Returns truncated text if longer than a limit
  // Need to pass in expanded to reactively update the text
  const truncatedText = (e) =>
    // expanded decides if we show the full text or truncated text
    !exceedsLimit || e ? text : text.slice(0, limit);
</script>

<span>
  {truncatedText(expanded)}
  {#if exceedsLimit && showReadMore}
    {expanded ? "" : "..."}
    <button
      class="read-more {size}"
      on:click={toggleExpanded}
      style={buttonStyle}
    >
      {expanded ? "Read less" : "Read more"}
    </button>
  {:else if exceedsLimit}
    ...
  {/if}
</span>
